"use strict";

(() => {
    const primaryOptionSelector = document.querySelector('.product-form__variants[data-has-stil-option] .product-form__option-selector');
    const benefitsButtons = document.querySelectorAll('.variant-benefits-block-wrapper .variant-benefits-block__buttons button');

    if(!primaryOptionSelector || !benefitsButtons.length) return;

    benefitsButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
            const targetSwatch = primaryOptionSelector.querySelector(`.variant-swatch:nth-of-type(${e.currentTarget.dataset.option}) input`);

            targetSwatch.click();
        })
    })
})();